import { render, staticRenderFns } from "./ProjectTestGroupList.vue?vue&type=template&id=cf7fcbd4&scoped=true&"
import script from "./ProjectTestGroupList.vue?vue&type=script&lang=ts&"
export * from "./ProjectTestGroupList.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectTestGroupList.vue?vue&type=style&index=0&id=cf7fcbd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7fcbd4",
  null
  
)

export default component.exports